import {
    CREATE_PROCESS_FLOW_REQUEST_DK,
    CREATE_PROCESS_FLOW_SUCCESS_DK,
    CREATE_PROCESS_FLOW_FAILURE_DK,
    DELETE_PROCESS_FLOW_REQUEST_DK,
    DELETE_PROCESS_FLOW_SUCCESS_DK,
    DELETE_PROCESS_FLOW_FAILURE_DK,
    FETCH_SINGLE_PROCESS_FLOW_REQUEST_DK,
    FETCH_SINGLE_PROCESS_FLOW_SUCCESS_DK,
    FETCH_SINGLE_PROCESS_FLOW_FAILURE_DK,
    FETCH_PROCESS_FLOW_REQUEST_DK,
    FETCH_PROCESS_FLOW_SUCCESS_DK,
    FETCH_PROCESS_FLOW_FAILURE_DK,
    UPDATE_PROCESS_FLOW_REQUEST_DK,
    UPDATE_PROCESS_FLOW_SUCCESS_DK,
    UPDATE_PROCESS_FLOW_FAILURE_DK,
    RESET_PROCESS_FLOW_INFO_DK,
    CREATE_PROCESS_FLOW_FORM_DK,
    UPDATE_PROCESS_FLOW_FORM_DK,
    NAVIGATE_PROCESS_FLOW_DK,
    NAVIGATE_PROCESS_FLOW_ADD_ON_DK,
    NAVIGATE_PROCESS_FLOW_SUPPLIER_DK,
    FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_SUCCESS_DK,
    FETCH_PROCESS_FLOW_WITHOUT_ID_SUCCESS_DK,
    FETCH_SEQUENCE_NUMBER_REQUEST_DK,
    FETCH_SEQUENCE_NUMBER_SUCCESS_DK,
    FETCH_SEQUENCE_NUMBER_FAILURE_DK
} from './processFlow.actionType';

export const PROCESS_FLOW_DK = 'processFlowDK';

let initialState = {
    loading: false,
    processFlowList: [],
    processFlowform: {
        fldDc: true,
        fldInward: true
    },
    selectedState: {},
    errorMessage: '',
    singleProcessFlow: {},
    programCategory: [],
    sequenceNumber: null,
    processFlowListWithoutId: [],
    isProcessFlow: false,
    isAddOnProcess: false,
    isSupplierProcess: false
};

export let processFlowDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROCESS_FLOW_REQUEST_DK:
        case CREATE_PROCESS_FLOW_REQUEST_DK:
        case UPDATE_PROCESS_FLOW_REQUEST_DK:
        case FETCH_SEQUENCE_NUMBER_REQUEST_DK:
        case FETCH_SINGLE_PROCESS_FLOW_REQUEST_DK:
        case DELETE_PROCESS_FLOW_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROCESS_FLOW_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processFlowList: updatePayload
            };
        case FETCH_PROCESS_FLOW_WITHOUT_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processFlowListWithoutId: updatePayload
            };
        case FETCH_SEQUENCE_NUMBER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                sequenceNumber: updatePayload
            };
        case CREATE_PROCESS_FLOW_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processFlowform: {
                    fldDc: true,
                    fldInward: true
                }
            };
        case UPDATE_PROCESS_FLOW_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processFlowform: {
                    fldDc: true,
                    fldInward: true
                }
            };
        case FETCH_SINGLE_PROCESS_FLOW_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processFlowform: updatePayload
            };
        case FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_SUCCESS_DK:
            if (payload == 41) {
                return {
                    ...state,
                    loading: false,
                    programCategory: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case DELETE_PROCESS_FLOW_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processFlowform: {
                    fldDc: true,
                    fldInward: true
                }
            };
        case RESET_PROCESS_FLOW_INFO_DK:
            return {
                ...state,
                processFlowform: {
                    fldDc: true,
                    fldInward: true
                }
            };
        case CREATE_PROCESS_FLOW_FORM_DK:
        case UPDATE_PROCESS_FLOW_FORM_DK:
            return {
                ...state,
                loading: false,
                processFlowform: {
                    ...state.processFlowform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PROCESS_FLOW_FAILURE_DK:
        case CREATE_PROCESS_FLOW_FAILURE_DK:
        case UPDATE_PROCESS_FLOW_FAILURE_DK:
        case FETCH_SINGLE_PROCESS_FLOW_FAILURE_DK:
        case DELETE_PROCESS_FLOW_FAILURE_DK:
        case FETCH_SEQUENCE_NUMBER_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_PROCESS_FLOW_ADD_ON_DK:
            return {
                ...state,
                isAddOnProcess: true,
                isSupplierProcess: false,
                isProcessFlow: false,
                singleProcessFlow: updatePayload.singleProcessFlow
            };
        case NAVIGATE_PROCESS_FLOW_SUPPLIER_DK:
            return {
                ...state,
                isSupplierProcess: true,
                isAddOnProcess: false,
                isProcessFlow: false,
                singleProcessFlow: updatePayload.singleProcessFlow
            };
        case NAVIGATE_PROCESS_FLOW_DK:
            return {
                ...state,
                isProcessFlow: true,
                isAddOnProcess: false,
                isSupplierProcess: false
            };
        default:
            return state;
    }
};
